module.exports = __webpack_public_path__ + "media/images/flags/fo-ccefb0b99dbb0bbb7894b5f72b59937d.svg";